import React from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from '../NavigationBar/NavigationBar';

function Layout() {
    // Имя пользователя сохраняет LoginScreen при входе
    const username = localStorage.getItem('lg_username') || 'User';

    return (
        <>
            <NavigationBar username={username} />
            <Outlet />
        </>
    );
}

export default Layout;
